export default "/_nuxt/614c61cdae1d4e390b588dfaa5fab2fa.svg";